/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface GoodsPassThruFleet {
  /**
   * Unit of measure
   */
  measure_unit?: GoodsPassThruFleet.MeasureUnitEnum | null;
  /**
   * NACS Product Code
   */
  product_code?: string | null;
}
export namespace GoodsPassThruFleet {
  export type MeasureUnitEnum = 'L' | 'G';
  export const MeasureUnitEnum = {
    L: 'L' as MeasureUnitEnum,
    G: 'G' as MeasureUnitEnum
  };
}
